import { sendGetHttpRequest, sendHttpRequest } from "lib/fetcher";

export async function getPresetEvent(
  orgId: string,
  cameraId: number,
  presetId: number,
  startAt: number,
  endAt: number,
) {
  return await sendGetHttpRequest(
    `/event/events/preset?paging.limit=1000&cameraId=${cameraId}&presetId=${presetId}&startAt=${startAt}&endAt=${endAt}`,
    orgId,
  );
}

export function getInspectionCameras(siteId: number, name: string) {
  return sendHttpRequest({
    method: "get",
    url: `/camera/cameras?with_support_inspection=true&siteId=${siteId}&name=${name}&page.limit=600`,
  });
}

export function getSiteList() {
  return sendHttpRequest({
    url: "/site/tree",
    method: "GET",
  });
}
